// @flow
import getHexColorComponents from './getHexColorComponents';

/**
 * Adds an alpha channel to a color whose hex value is known. For example, for white and 50% opacity
 * you would call the function with `rgba('#ffffff', 0.5)` and the output would be
 * `'rgba(255, 255, 255, 0.5)'`.
 *
 * @param hexColor - A 6-digit CSS hex color, ex. #A1B2C3
 * @param alpha - The alpha component of a CSS rgba color
 * @return An rgba CSS color string, ex. rgba(1, 2, 3, 0.4)
 */
const rgba = (hexColor: string, alpha: number): string => {
  const { red, green, blue } = getHexColorComponents(hexColor);
  return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
};

export default rgba;
